import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 1rem;
`

export const NotActiveProvider = styled.div`
    color: #fff;
    line-height: 3rem;
    text-align: center;
`;